import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Typography,
  withStyles,
} from "@material-ui/core";

// Custom Switch with dynamic color
const CustomSwitch = withStyles((theme) => ({
  switchBase: {
    color: theme.palette.grey[300],
    "&$checked": {
      color: (props) => props.clientcolor || theme.palette.primary.main,
    },
    "&$checked + $track": {
      backgroundColor: (props) =>
        props.clientcolor || theme.palette.primary.main,
    },
  },
  checked: {},
  track: {},
}))(Switch);

export default function DimensionSourcePanel({
  isUserSelection,
  tableName,
  tableId,
  variants,
  selectedVariantId,
  onVariantChange,
  onUse,
  isLoading,
  clientColor,
  showInheritToggle,
  inheritFromNode2,
  onInheritToggle,
}) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      style={{
        width: 250,
        minWidth: 250,
        maxWidth: 250,
        paddingLeft: 16,
        paddingRight: 16,
      }}
    >
      {/* Source */}
      <Box>
        <Typography
          variant="caption"
          style={{ color: "#666", fontWeight: 500 }}
        >
          Source
        </Typography>
        {isUserSelection ? (
          <Typography
            variant="body2"
            style={{ fontStyle: "italic", marginTop: 4 }}
          >
            User Selection
          </Typography>
        ) : (
          <Box display="flex" alignItems="center" style={{ marginTop: 4 }}>
            <Typography variant="body2" style={{ fontWeight: 600 }}>
              {tableName}
            </Typography>
            <Chip
              label={tableId}
              size="small"
              style={{
                height: 20,
                fontSize: "0.7rem",
                backgroundColor: "#f0f0f0",
                color: "#666",
                marginLeft: 8,
              }}
            />
          </Box>
        )}
      </Box>

      {/* Inherit Toggle (only for location_sellout) */}
      {showInheritToggle && (
        <Box style={{ marginTop: 16 }}>
          <Box display="flex" alignItems="center" style={{ marginBottom: 4 }}>
            <CustomSwitch
              checked={inheritFromNode2}
              onChange={(e) => onInheritToggle(e.target.checked)}
              size="small"
              clientcolor={clientColor || "#1976d2"}
            />
            <Typography
              variant="body2"
              style={{
                fontSize: "0.875rem",
                color: "#333",
                fontWeight: 500,
                marginLeft: 8,
                whiteSpace: "normal",
                lineHeight: 1.25,
              }}
            >
              Usar mesmas UF&apos;s de Sellthrough
            </Typography>
          </Box>
          <Typography
            variant="caption"
            style={{
              fontSize: "0.75rem",
              color: "#999",
              fontStyle: "italic",
              display: "block",
              textAlign: "center",
            }}
          >
            UF venda em sellthrough = UF venda sellout, sem invasões
          </Typography>
        </Box>
      )}

      {/* Variant Selector + Use Button (only for table-based) */}
      {!isUserSelection && (
        <>
          <FormControl size="small" fullWidth style={{ marginTop: 24 }}>
            <InputLabel>Variant</InputLabel>
            <Select
              value={selectedVariantId || ""}
              onChange={(e) => onVariantChange(e.target.value)}
            >
              {variants.map((variant) => (
                <MenuItem key={variant.variant_id} value={variant.variant_id}>
                  {variant.variant_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            onClick={onUse}
            disabled={!selectedVariantId || isLoading}
            startIcon={
              isLoading && <CircularProgress size={16} color="inherit" />
            }
            style={{
              backgroundColor:
                !selectedVariantId || isLoading
                  ? undefined
                  : clientColor || "#1976d2",
              color: "#fff",
              marginTop: 16,
            }}
          >
            {isLoading ? "Loading..." : "Use"}
          </Button>
        </>
      )}
    </Box>
  );
}

DimensionSourcePanel.propTypes = {
  isUserSelection: PropTypes.bool.isRequired,
  tableName: PropTypes.string,
  tableId: PropTypes.string,
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      variant_id: PropTypes.number.isRequired,
      variant_name: PropTypes.string.isRequired,
    }),
  ),
  selectedVariantId: PropTypes.number,
  onVariantChange: PropTypes.func,
  onUse: PropTypes.func,
  isLoading: PropTypes.bool,
  clientColor: PropTypes.string,
  showInheritToggle: PropTypes.bool,
  inheritFromNode2: PropTypes.bool,
  onInheritToggle: PropTypes.func,
};
